module.exports = __webpack_public_path__ + "e656c7b629fdab82dd7d9dd98e8b7275.png";